import React from "react";
import { colors2, UI_BODY_SM, UI_CAPTION_SEMIBOLD } from "oolib";
import { DisplayIcon } from "oolib/dist/utils/comps/DisplayIcon";
import { Description } from "./IntegrationModalShell";
import { Actions } from "./styled";

// Small display pieces shared by the integration popups (see modals/).

// Grey caption box: what an import does, or a warning under a field.
export const caption = (text) => (
  <Description>
    <UI_CAPTION_SEMIBOLD style={{ color: colors2.grey60 }}>
      {text}
    </UI_CAPTION_SEMIBOLD>
  </Description>
);

// Separator between parts of one line, e.g. last sync's time • rows • source.
export const Dot = () => (
  <span style={{ color: colors2.grey40, margin: "0 6px" }}>•</span>
);

export const SCHEDULE_LABELS = {
  hourly: "Hourly",
  daily: "Daily",
  weekly: "Weekly",
  "one-time": "One-time",
};

// A dataset's schedule at rest; hidden while its row is hovered (rowSchedule).
export const ScheduleLabel = ({ schedule }) => (
  <Actions className="rowSchedule" style={{ gap: 4, color: colors2.grey60 }}>
    {schedule !== "one-time" && (
      <DisplayIcon icon="ArrowsClockwise" size={14} color={colors2.grey60} />
    )}
    <UI_BODY_SM style={{ color: colors2.grey60 }}>
      {SCHEDULE_LABELS[schedule]}
    </UI_BODY_SM>
  </Actions>
);

export const FREQUENCIES = [
  { display: "Hourly", value: "hourly" },
  { display: "Daily", value: "daily" },
  { display: "Weekly", value: "weekly" },
];

// The v1 date range picker works in YYYY-MM-DD strings.
export const isoDaysAgo = (n) =>
  new Date(Date.now() - n * 86400000).toISOString().slice(0, 10);
